var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "525px",
    height: "525px",
    viewBox: "0 0 525 525",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "protein_fish") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "protein_fish",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#8898AA",
    strokeWidth: 20,
    cx: 263,
    cy: 263,
    r: 240
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.620647,162.261687 C250.540216,171.969157 254.326804,175.166466 254.4647,175.290475 C262.576937,178.714313 288.31946,173.421359 327.802135,216.372099 L305.73071,217.487384 C305.73071,217.487384 329.978018,245.344802 340.594099,264.070754 C350.808205,281.306898 353.317325,296.610771 359.133242,297.449391 C389.164797,302.191363 475.593006,287.845464 432.430921,314.573567 C410.17817,326.920194 388.800047,324.655083 390.722644,349.700877 C393.15592,382.599864 413.547949,425.867342 357.271396,353.062847 C341.783737,334.04349 339.67603,320.229101 331.678097,323.169844 C306.189551,332.389808 241.980652,310.435487 246.268127,320.469215 C246.785509,322.398142 247.68352,324.810499 248.661717,327.191574 L248.93026,327.839795 C250.910844,332.582062 253.102915,337.012037 253.102915,337.012037 C253.102915,337.012037 227.796993,334.998411 204.602295,314.049043 C181.407793,293.099338 176.172043,282.518124 176.172043,282.518124 L176.119632,282.481606 C174.416562,281.290445 131.652118,251.045024 112.881212,204.405457 C112.885709,204.408053 106.34201,182.99414 119.65024,173.041744 C134.45073,162.689431 181.063378,151.810242 216.620647,162.261687 Z M172.339746,172.339746 C166.783559,172.339746 162.339746,176.783559 162.339746,182.339746 C162.339746,187.895933 166.783691,192.339746 172.339746,192.339746 C177.895933,192.339746 182.339746,187.895933 182.339746,182.339746 C182.339746,176.783559 177.895801,172.339746 172.339746,172.339746 Z",
    id: "Combined-Shape",
    fill: "#8898AA",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinFish);
export default __webpack_public_path__ + "static/media/protein_fish.3fed61e2c931478b77ae919596cd59e6.svg";
export { ForwardRef as ReactComponent };